import generatedCatalog from "./itemBuffCatalog.generated.json";

const normalizeEffect = (effect = {}) => {
  const effectId = Math.trunc(Number(effect?.effectId || 0));
  const value = Number(effect?.value || 0);
  if (!Number.isFinite(effectId) || effectId <= 0 || !Number.isFinite(value) || value === 0) return null;
  return { effectId, value };
};

const normalizeDurationOption = (option = {}) => {
  const durationSeconds = Math.max(0, Math.floor(Number(option?.durationSeconds || 0)));
  const level = Math.trunc(Number(option?.level || 0));
  const quality = Math.max(0, Math.trunc(Number(option?.quality || 0)));
  const durationLabel = String(option?.durationLabel || "").trim();
  if (!durationSeconds && !durationLabel) return null;
  return {
    level: Number.isFinite(level) ? level : 0,
    durationSeconds,
    durationLabel,
    quality,
  };
};

export const ITEM_BUFF_CATALOG = Array.isArray(generatedCatalog?.buffs)
  ? generatedCatalog.buffs.map((buff = {}) => ({
    itemGid: Math.trunc(Number(buff?.itemGid || 0)),
    name: String(buff?.name || "").trim(),
    category: String(buff?.category || "").trim(),
    categoryLabel: String(buff?.categoryLabel || "").trim(),
    description: String(buff?.description || "").trim(),
    durationOptions: (Array.isArray(buff?.durationOptions) ? buff.durationOptions : [])
      .map(normalizeDurationOption)
      .filter(Boolean),
    effects: (Array.isArray(buff?.effects) ? buff.effects : []).map(normalizeEffect).filter(Boolean),
    aliases: (Array.isArray(buff?.aliases) ? buff.aliases : [])
      .map((alias) => String(alias || "").trim())
      .filter(Boolean),
  })).filter((buff) => buff.itemGid > 0 && buff.name && buff.effects.length > 0)
  : [];

export default ITEM_BUFF_CATALOG;
